/** スワイプと判定する最小の移動量(px) */
export const SWIPE_THRESHOLD = 50;

export type SwipeDirection = "previous" | "next" | null;

/**
 * 指の移動量からスワイプの向きを決める。
 *
 * 縦方向の移動が横より大きいときは無視する。写真を見ながら縦にスクロールする
 * 動作を、送り操作として誤って拾わないため。
 */
export function swipeDirectionOf(deltaX: number, deltaY: number): SwipeDirection {
  if (Math.abs(deltaX) < SWIPE_THRESHOLD) return null;
  if (Math.abs(deltaY) > Math.abs(deltaX)) return null;
  // 右へ払うと前の写真、左へ払うと次の写真
  return deltaX > 0 ? "previous" : "next";
}

/** 端で止める。循環させると「最初に戻った」ことに気づきにくい */
export function stepIndex(current: number, direction: SwipeDirection, length: number): number {
  if (direction === null || length === 0) return current;
  const next = direction === "next" ? current + 1 : current - 1;
  return Math.min(Math.max(next, 0), length - 1);
}
